import React from 'react';
import { Helmet } from "react-helmet";
import {useSelector} from "react-redux";

const HeadTags = () => {
    const rootState = useSelector(state => state);
    const path = rootState.router.location.pathname;
    const baseUrl = "https://nitaku-prod.web.com";

    let title = "Judge!",
        image = 'https://firebasestorage.googleapis.com/v0/b/nitaku-dev-2d298.appspot.com/o/src%2Ffavicon.ico?alt=media&token=bb8035de-759d-496e-b722-82fb91f406c1';

    switch (path) {
        case "/post":
            title = "質問を投稿｜Judge!";
            break;
        case "/profile":
            title = "マイページ｜Judge!";
            break;
        case /\/detail\/*/.test(path):
            title = `${rootState.detail.question}｜Judge!`;
            image = rootState.detail.image;
            break;
        default:
            title = "Judge!";
            break
    }

    return (
        <Helmet
            title={title}
            meta={[
                { property: 'og:type', content: 'website' },
                { property: 'og:url', content: baseUrl+path },
                { property: 'og:image', content: image},
                { property: 'og:title', content: title },
                { property: 'og:description', content: '匿名質問投稿SNS「Judge!」｜あたなはどっちを選ぶ？' },
                { name: 'twitter:card', content: "summary_large_image" },
                { name: 'twitter:site', content: baseUrl+path },
                { name: 'twitter:title', content: title },
                { name: 'twitter:description', content: '匿名質問投稿SNS「Judge!」｜あたなはどっちを選ぶ？' },
                { name: 'twitter:image', content: image },
            ]}
        />
    );
};

export default HeadTags;